var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full border bg-white mt-12 relative bottom-0"},[_c('div',{staticClass:"flex px-2 w-full md:w-10/12 lg:w-8/12 m-auto"},[_c('div',{staticClass:"text-center flex-1"},[_vm._v("\n           All Rights Reserved © "+_vm._s(_vm.getYear())+"  | "),_c('a',{attrs:{"href":"./PrivacyPolicy","target":"_blank"}},[_vm._v("Privacy Policy")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277c917e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 